function filterMobile(){

    if (window.innerWidth < 768) {
        $(".filter__btn").on('click', function() {
            $(this).toggleClass('filter-open');
        });
    }
    else {
        $(".filter__btn").on('click', function() {
            Event.preventDefault();
        });
    }

}

module.exports = filterMobile;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/03_filter.js